import { motion } from "framer-motion";
import { INDUSTRIES } from "@/data/site";
import { Icon } from "@/lib/Icon";
import { Reveal, stagger, item } from "@/lib/motionPrimitives";

export default function Industries() {
  return (
    <section id="industries" className="relative py-24 md:py-32" data-testid="industries">
      <div className="container-x">
        <Reveal>
          <p className="overline">Sectors We Cover</p>
          <h2 className="mt-4 font-display text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight">
            Industries We Serve
          </h2>
        </Reveal>

        <motion.div
          variants={stagger}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, margin: "-60px" }}
          className="mt-14 grid gap-5 sm:grid-cols-2 lg:grid-cols-4"
        >
          {INDUSTRIES.map((ind, i) => (
            <motion.article
              key={ind.title}
              variants={item}
              data-testid={`industry-card-${ind.title}`}
              className="group relative flex h-56 flex-col justify-end overflow-hidden rounded-3xl border border-border p-6"
            >
              <img
                src={`${ind.image}?auto=format&fit=crop&w=800&q=70`}
                alt={ind.title}
                loading="lazy"
                className="absolute inset-0 h-full w-full object-cover transition-transform duration-700 group-hover:scale-110"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/85 via-black/40 to-black/20" />
              <div className="relative z-10">
                <div className="mb-3 flex h-11 w-11 items-center justify-center rounded-xl bg-primary text-primary-foreground">
                  <Icon name={ind.icon} className="h-5 w-5" />
                </div>
                <h3 className="font-display text-lg font-semibold text-white">{ind.title}</h3>
              </div>
            </motion.article>
          ))}
        </motion.div>
      </div>
    </section>
  );
}
